import { authStore } from 'store/mobx/auth.store';
import { address_server, address_server_short, API_V2 } from '../config';
import { error } from '../utils/handlerError';
import axios from 'axios';

const LISTS = 'lists';
const DEVICE_MODELS = 'device-models';
const DEVICES = 'devices';

export async function getListRules() {
  const token = authStore.token;
  const res = await (await fetch(address_server + 'list/rules?token=' + token)).json();
  if (res.success) {
    return res.result.groups;
  }
  error('getListRules', res);
  return [];
}

export async function getListReports() {
  const token = authStore.token;
  const res = await (
    await fetch(address_server + 'report/reports?mode=list&limit=1000&token=' + token)
  ).json();
  if (res.success) {
    return res.result;
  }
  error('getListReports', res);
  return [];
}

export async function getSections() {
  const token = authStore.token;
  const res = await (await fetch(address_server + 'list/sections?token=' + token)).json();
  if (res.success) {
    return res.result;
  }
  error('getSections', res);
  return [];
}

export async function getListTypeStorages() {
  const token = authStore.token;
  const res = await (await fetch(address_server + 'list/type/storage?token=' + token)).json();
  if (res.success) {
    return res.result;
  }
  error('getListTypeStorages', res);
  return [];
}

export async function getListTypeFields() {
  const token = authStore.token;
  const res = await fetch(address_server + 'list/type/fields?token=' + token);
  const data = await res.json();
  if (data.success) {
    return data.result;
  }
  error('getListTypeFields', data);
  return [];
}

export async function getListUnits() {
  const res = await fetch(address_server + 'list/units');
  const data = await res.json();
  if (data.success) {
    return data.result;
  }
  error('getListUnits', data);
  return [];
}

export async function getTypeSamples() {
  const token = authStore.token;
  const res = await (await fetch(address_server + 'list/type/samples?token=' + token)).json();
  if (res.success) {
    return res.result;
  }
  error('getTypeSamples', res);
  return [];
}

export async function getListIcon() {
  const token = authStore.token;
  const res = await (await fetch(address_server + 'list/icons?token=' + token)).json();
  if (res.success) {
    return res.result;
  }
  error('getListIcon', res);
  return [];
}

export async function getListPacks(id) {
  const token = authStore.token;
  if (!id) return [];
  const res = await (
    await fetch(address_server + 'storage/packs?token=' + token + '&storage=' + id)
  ).json();
  if (res.success) {
    return res.result;
  }
  error('getListPacks', res);
  return [];
}

export async function getPack(id) {
  const token = authStore.token;
  if (!id) return [];
  const res = await (
    await fetch(address_server + 'storage/pack?token=' + token + '&id=' + id)
  ).json();
  if (res.success) {
    return res.result;
  }
  error('getListPacks', res);
  return [];
}

export async function getListBarcodes() {
  const token = authStore.token;
  const res = await (await fetch(address_server + 'list/type/barcodes?token=' + token)).json();
  if (res.success) {
    return res.result;
  }
  error('getListPacks', res);
  return [];
}

export async function getAllUserFields({ page, search, sorting }, category = undefined) {
  const { data } = await axios(`${address_server_short}${API_V2}/${LISTS}/user-fields`, {
    withCredentials: true,
    params: {
      page,
      search,
      sorting: sorting?.field && sorting?.type ? JSON.stringify(sorting) : undefined,
      category,
    },
  });

  if (data.success) {
    if (data.result) return data.result;
    return [];
  }
  error('getAllUserFields', data);
}

export async function getAllProtocols({ search, sorting } = {}, id_group = undefined) {
  const { data } = await axios(`${address_server_short}${API_V2}/${LISTS}/protocols`, {
    withCredentials: true,
    params: {
      search,
      sorting: sorting?.field && sorting?.type ? JSON.stringify(sorting) : undefined,
      id_group,
    },
  });

  if (data.success) {
    if (data.result) return data.result;
    return [];
  }
  error('getAllProtocols', data);
}

export async function getAllProtocolGroups({ search, sorting } = {}) {
  const { data } = await axios(`${address_server_short}${API_V2}/${LISTS}/protocol-groups`, {
    withCredentials: true,
    params: {
      search,
      sorting: sorting?.field && sorting?.type ? JSON.stringify(sorting) : undefined,
    },
  });

  if (data.success) {
    if (data.result) return data.result;
    return [];
  }
  error('getAllProtocolGroups', data);
}

export async function getSamplesByType(typeId, searchStr) {
  const { data } = await axios(`${address_server_short}${API_V2}/${LISTS}/samples/${typeId}`, {
    withCredentials: true,
    params: {
      id_general_or_barcode: searchStr,
    },
    method: 'GET',
  });

  if (data.success) {
    if (data.result) return data.result;
    return [];
  }
  error('getSamplesByType', data);
}

export async function getSamplesSourcesByType(typeId, searchStr) {
  const { data } = await axios(`${address_server_short}${API_V2}/${LISTS}/sample-sources`, {
    withCredentials: true,
    params: {
      search: searchStr,
      id_type: typeId,
    },
    method: 'GET',
  });

  if (data.success) {
    if (data.result) return data.result;
    return [];
  }
  error('getSamplesSourcesByType', data);
}

export async function getListDeviceModels({ search, sorting } = {}) {
  const { data } = await axios(`${address_server_short}${API_V2}/${LISTS}/${DEVICE_MODELS}`, {
    withCredentials: true,
    params: {
      search,
      sorting: sorting?.field && sorting?.type ? JSON.stringify(sorting) : undefined,
    },
  });

  if (data.success) {
    if (data.result) return data.result;
    return [];
  }
  error('getListDeviceModels', data);
}

export async function getListDevices({ search, sorting } = {}) {
  const { data } = await axios(`${address_server_short}${API_V2}/${LISTS}/${DEVICES}`, {
    withCredentials: true,
    params: {
      search,
      sorting: sorting?.field && sorting?.type ? JSON.stringify(sorting) : undefined,
    },
  });

  if (data.success) {
    if (data.result) return data.result;
    return [];
  }
  error('getListDevices', data);
}
